import { Component, inject, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Store } from '@ngxs/store'
import {
  AttendanceState,
  EmployeeAttendanceDetails,
  IEmplyeeAttendanceDetailReponse,
  IEmplyeeAttendanceItem
} from 'attendance-data-access'
import { finalize, Observable } from 'rxjs'

@UntilDestroy()
@Component({
  selector: 'lla-attendance-employee-dialog',
  templateUrl: './attendance-employee-dialog.component.html',
  styleUrls: ['./attendance-employee-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AttendanceEmployeeDialogComponent implements OnInit {
  employeeDetails$: Observable<IEmplyeeAttendanceDetailReponse> = inject(Store).select(
    AttendanceState.employeeDetails
  )
  employeeDetails?: IEmplyeeAttendanceDetailReponse

  dataSource: IEmplyeeAttendanceItem[] = []
  displayedColumns = ['clockIn', 'total', 'locationName', 'timeZone', 'note']

  isLoading = false

  constructor(
    private store: Store,
    public dialogRef: MatDialogRef<AttendanceEmployeeDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      employeeId: string
      locationId: string
      workingDay: Date
    }
  ) {}

  ngOnInit(): void {
    this.employeeDetails$.pipe(untilDestroyed(this)).subscribe((res) => {
      if (res) {
        this.employeeDetails = res
        this.dataSource = [
          ...(res.attendances ?? []),
          {
            clockIn: 'Total worked hours',
            total: res.grandTotal
          }
        ]
      } else {
        this.employeeDetails = undefined
        this.dataSource = []
      }
    })

    this.getData()
  }

  getData() {
    this.isLoading = true
    this.store
      .dispatch(new EmployeeAttendanceDetails(this.data.employeeId, this.data.workingDay))
      .pipe(
        untilDestroyed(this),
        finalize(() => (this.isLoading = false))
      )
      .subscribe()
  }
}
